export default __webpack_public_path__ + "static/media/zayed-project-4.15606971.webp";